import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlaceholderService {
  private placeholderSource = new BehaviorSubject<string>('Default Placeholder');
  placeholder$ = this.placeholderSource.asObservable();

  setPlaceholder(value: any) {
    this.placeholderSource.next(value);
  }
}
